// External deps
import React , {createContext, useEffect, useState }from 'react';
import PropTypes from 'prop-types';
// Internal deps
import PROCESS_TYPE from '../utils/processType';
import useApp from '../hooks/useApp';
import useUserPermisions from '../hooks/useUserPermisions';
import { URL_ADMINISTRACION } from '../constants/host';
import { clearStorage, getItemStorage } from '../utils/utils';
import { constantsSession } from '../constants/constants';
import useLoading from '../hooks/useLoading';
import {getFirstLoginAdapter, getInfoProfileAdapter } from '../adapters/userRequestsAdapter';
import { showError } from '../utils/toastUtils';
import PROFILE_STATUS from '../utils/profileStatus';

export const UserProfileContext = createContext();
UserProfileContext.displayName= 'UserProfileContext';

const UserProfileProvider = ({children}) => {
  const accessToken = getItemStorage(constantsSession.ACCESS_TOKEN, false);
  const expireIn = getItemStorage(
    constantsSession.ACCESS_TOKEN_EXPIRE_IN,
    false
  );
  const refreshToken = getItemStorage(constantsSession.REFRESH_TOKEN, false);
  const accessTokenDate = getItemStorage(
    constantsSession.ACCESS_TOKEN_DATE,
    false
  );
  const { provName } = useApp();
  const { setLoading } = useLoading();
    const { userPermissions, isUserExternal } = useUserPermisions();
    // to show button "Editar perfil"
    const [canBeEditMeProfileValue, setCanBeEditMeProfileValue] = useState(false);
    
    // info user logger
    const [infoUserLogger, setInfoUserLogger] = useState({});

    // to show a modal with warning message - should be complite profile
    const [showModalInfo, setShowModalInfo] = useState({
      show:false,
      strongMessage: "Para comenzar a utilizar Y-Click tenés que revisar si es necesario cargar datos de propiedades",
      spanMessage: "Algunas de estos datos pueden ser: UUNN, grupo y/o servicio",
      changeContentModalInfo: false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleCanEditMeProfile = () => {
      setCanBeEditMeProfileValue(userPermissions.userProfile?.canEditMeProfile);
    };
    
    const handleRedirectToMeProfile = ({ process, requestId, userName }) => {
      const navigator = window.location;
        // route to complite profile
        if (isUserExternal) {
          const requestType = process === PROCESS_TYPE.finalized ? 'finished' : 'pending';
          navigator.replace(`${URL_ADMINISTRACION}/#/edit-external-user/${requestType}/${requestId}/${userName}?at=${accessToken}&ei=${expireIn}&rt=${refreshToken}&atd=${accessTokenDate}&ispr=${provName}&fhome=${true}`);
        } else {
          navigator.replace(`${URL_ADMINISTRACION}/#/edit-profile-internal-user/${requestId}/${userName}?at=${accessToken}&ei=${expireIn}&rt=${refreshToken}&atd=${accessTokenDate}&ispr=${provName}&fhome=${true}`);
        }
       clearStorage();
      };
    
      // Get info about user logger when a have roles and permissions
      const handleGetInfoUserLogger = (changeContent) => {
        setLoading(true);
        Promise.all([getFirstLoginAdapter(), getInfoProfileAdapter()])
          .then(([resFirstLogin, resInfoProfile]) => {
            setInfoUserLogger((prevState) => ({
              ...prevState,
              ...resInfoProfile
            }));         
            setShowModalInfo((prevState) =>({...prevState,
              strongMessage: changeContent ? 'Para comenzar a utilizar Y-Click es necesario cargar datos de propiedades': prevState.strongMessage,
              spanMessage: changeContent ? 'Comunicate con un administrador': prevState.spanMessage,
              changeContentModalInfo:  changeContent,
              show: resFirstLogin !== PROFILE_STATUS.completed}));        
            setLoading(false);
          }).catch((err) => {
            setInfoUserLogger((prevState) => ({
              ...prevState
            }));
            setShowModalInfo((prevState) => ({...prevState, show: false}));
            showError(err); 
            setLoading(false);
          });       
      };
    useEffect(() => {
      if(Object.keys(userPermissions).length !== 0){
        handleCanEditMeProfile();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPermissions]);

    return (
        <UserProfileContext.Provider
          value={{
            canBeEditMeProfileValue,
            handleRedirectToMeProfile,
            handleCanEditMeProfile,
            handleGetInfoUserLogger,
            infoUserLogger,
            showModalInfo,
            setShowModalInfo
          }}
        >
          {children}
        </UserProfileContext.Provider>
      );
};
UserProfileProvider.propTypes = {
    children: PropTypes.element.isRequired
  };
  
export default UserProfileProvider;